// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export interface GoogleAutoCompleteAddress {
    address1?: string;
    locality?: string;
    stateAbbreviation?: string;
    postalCode?: string;
    countryAbbreviation?: string;
}

export const initGooglePlacesAutoComplete = (input: HTMLInputElement, callback: () => void) => {
    const autoComplete = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: ["us"] },
        fields: ["address_component", "geometry"],
        types: ["address"],
    });
    autoComplete.addListener("place_changed", callback);
    return autoComplete;
};

export const getGooglePlacesFullAddress = (autoComplete: google.maps.places.Autocomplete) => {
    const place = autoComplete.getPlace();

    const resultAddress = {} as any;

    // Get each component of the address from the place details,
    for (const component of place.address_components || []) {
        const componentType = component.types[0];

        if (componentType === "street_number") {
            resultAddress.address1 = component.long_name;
        }

        if (componentType === "route") {
            resultAddress.address1 = `${resultAddress.address1 || ""} ${component.long_name}`;
        }

        if (componentType === "locality") {
            resultAddress.locality = component.long_name;
        }

        if (componentType === "administrative_area_level_1") {
            resultAddress.stateAbbreviation = component.short_name;
        }

        if (componentType === "postal_code") {
            resultAddress.postalCode = component.long_name;
        }

        if (componentType === "postal_code_suffix") {
            resultAddress.postalCode = `${resultAddress.postalCode || ""}-${component.long_name}`;
        }

        if (componentType === "country") {
            resultAddress.countryAbbreviation = component.short_name;
        }
    }

    return resultAddress;
};
